export function sliderEvents() {
	const sliders = document.querySelectorAll(".ilawyer-slider");

	sliders.forEach((slider) => {
		const initType = slider.getAttribute("data-init-event") || "hover";
		if (initType === "scroll") {
			attachScrollInit(slider);
		} else {
			attachClickInit(slider);
		}
	});
}

export async function loadSlider(slider) {
	if (!slider?.dataset?.sliderInitialized) {
		try {
			const sliderModule = await import("./slider.js");
			await sliderModule.initSlider(slider);
			slider.dataset.sliderInitialized = "true";
		} catch (err) {
			console.error("Failed to load module:", err);
		}
	}
}

function attachClickInit(slider) {
	//if (!slider || slider.dataset.clickInitAttached) return; // init guard if i need it, but not now
	//slider.dataset.clickInitAttached = "true";
	const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;

	const nextButton = slider.querySelector('[data-ilawyer-button="next"]');
	const prevButton = slider.querySelector('[data-ilawyer-button="prev"]');
	if (nextButton) {
		nextButton.addEventListener(
			"pointerdown",
			async (event) => {
				event.stopPropagation();
				await loadSlider(slider);
				nextButton.click();
			},
			{ once: true, passive: true }
		);
	}
	if (prevButton) {
		prevButton.addEventListener(
			"pointerdown",
			async (event) => {
				event.stopPropagation();
				await loadSlider(slider);
				prevButton.click();
			},
			{ once: true, passive: true }
		);
	}
	const tracks = slider.querySelectorAll(".ilawyer-slider-track, .ilawyer-pagination");
	if (tracks.length > 0) {
		tracks.forEach((track) => {
			const swipeState = { initialX: null, initialY: null };
			// Define the touchstart handler.
			const touchStartHandler = (e) => {
				e.stopPropagation();
				swipeState.initialX = e.touches[0].clientX;
				swipeState.initialY = e.touches[0].clientY;
			};
			// Define the touchend handler.
			const touchEndHandler = async (e) => {
				e.stopPropagation();
				if (swipeState.initialX === null || swipeState.initialY === null) return;
				const currentX = e.changedTouches[0].clientX;
				const currentY = e.changedTouches[0].clientY;
				const diffX = swipeState.initialX - currentX;
				const diffY = swipeState.initialY - currentY;
				// Reset swipe state.
				swipeState.initialX = null;
				swipeState.initialY = null;
				const threshold = 30; // Minimum swipe distance in pixels.
				if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > threshold) {
					await loadSlider(slider);
					// Remove the external swipe handlers after loading.
					if (slider.dataset.sliderInitialized) {
						track.removeEventListener("touchstart", touchStartHandler);
						track.removeEventListener("touchend", touchEndHandler);
					}
					// Determine swipe direction and dispatch a custom event.
					const direction = diffX > 0 ? "swipe left" : "swipe right";
					const swipeEvent = new CustomEvent("sliderSwipe", {
						bubbles: true,
						cancelable: true,
						detail: { direction },
					});
					slider.dispatchEvent(swipeEvent);
				} else {
					// If the movement isn't considered a swipe (a tap), load the slider
					// and remove external swipe events.
					await loadSlider(slider);
					if (slider.dataset.sliderInitialized) {
						track.removeEventListener("touchstart", touchStartHandler);
						track.removeEventListener("touchend", touchEndHandler);
					}
				}
			};
			// Attach the touch events (without once so they fire on each interaction until removed).
			track.addEventListener("touchstart", touchStartHandler, { passive: true });
			track.addEventListener("touchend", touchEndHandler, { passive: true });
		});
	}

	// For non-touch devices, preload the slider on mouseenter (fire only once, passive).
	if (!isTouchDevice) {
		slider.addEventListener(
			"mouseenter",
			(e) => {
				e.stopPropagation();
				loadSlider(slider);
			},
			{ once: true, passive: true }
		);
	}
}

function attachScrollInit(slider) {
	const observer = new IntersectionObserver(
		(entries, obs) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					import("./slider.js").then((mod) => mod.initSlider(slider));
					obs.unobserve(entry.target);
				}
			});
		},
		{ rootMargin: "0px 0px 200px 0px" }
	);
	observer.observe(slider);
}
